import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'

// Components
import { Box, Grid } from '@mui/material'
import { CustomController } from '../../../common/CustomController'
import BankAccountsList from './BankAccountsList'

// Others
import { AccountType, useFetchRetainerAccountLazyQuery } from '../../../../../generated'
import { GRAPHQL_QUERY_POLICY } from '../../../../constants'
import InfoTooltip from '../../../common/InfoTooltip'
import { CustomDatePickerController } from '../../../common/CustomDatePickerRController'

const ContingencyBillingForm = () => {
  const { setValue, watch } = useFormContext()

  const [fetchRetainerAccount] = useFetchRetainerAccountLazyQuery({
    ...GRAPHQL_QUERY_POLICY,
    variables: undefined,
    onError() {},
    onCompleted(data) {
      if (data?.fetchRetainerAccount) {
        setValue('billing.retainerAccountId', data.fetchRetainerAccount.id)
      }
    }
  })

  useEffect(() => {
    const retainerAccountId = watch('billing.retainerAccountId')

    if (!retainerAccountId) {
      fetchRetainerAccount()
    }
  }, [fetchRetainerAccount, watch])

  return (
    <Grid container item rowSpacing={2.5}>
      <Grid item xs={12}>
        <CustomController
          fieldType="number"
          controllerName="billing.contingencySettlementAmount"
          controllerLabel="Est. Settlement Amount ($)"
          dollarAdornment
          sx={{ my: 0 }}
        />
      </Grid>

      <Grid item xs={12}>
        <CustomController
          fieldType="number"
          controllerName="billing.contingencyShare"
          controllerLabel="Contingency Share (%)"
          sx={{ my: 0 }}
        />
      </Grid>
      <Grid item xs={12}>
        <Box mt={2.5}>
          <CustomDatePickerController
            controllerName="billing.pauseBillingUntil"
            controllerLabel="Billing Paused Until"
            sx={{ my: 0 }}
          />
          <InfoTooltip info="Billing paused means that the monthly retainer amount and special payments (if any) will not be charged until the date (if selected) in above field. However, all the expense entries, cost entries or other legal fee entries will still be part of the monthly bill." />
        </Box>
      </Grid>

      <Grid item xs={12}>
        <BankAccountsList name="billing.retainerAccountId" title="Bank Account"/>
        <InfoTooltip info="Make sure to choose the bank account. For Contingency Billing, the bank account should be trust account but you can choose any bank account." />
      </Grid>
    </Grid>
  )
}

export default ContingencyBillingForm
